import {
  always,
  any,
  complement,
  either,
  filter,
  includes,
  isEmpty,
  map,
  omit,
  pick,
  pipe,
  values,
} from "ramda";
import { allPropsPass, hasIntersection } from "../../utils/fp.utils";
import { normalizeString } from "../../utils/string.utils";

const getSearchableValues = pipe(
  pick(["username", "firstName", "lastName", "bio"]),
  values,
  filter(Boolean),
  map(normalizeString),
);

export const filterPredicate =
  ({ coachesFilter, favoritesMaybe, omitKeys = [] }) =>
  (coach) =>
    allPropsPass(
      omit(omitKeys, {
        languages: either(isEmpty, hasIntersection(coach.languages)),
        fields: either(isEmpty, hasIntersection(coach.fields)),
        prices: either(isEmpty, hasIntersection([coach.rate])),
        primaryRoles: either(isEmpty, hasIntersection(coach.primaryRoles)),
        timezones: either(isEmpty, includes(coach.timeZone)),
        // experience: ([from, to] = []) => (!from || coach.experience >= from) && (!to || coach.experience <= to),
        search: (searchStr) =>
          !searchStr ||
          pipe(
            getSearchableValues,
            any(includes(normalizeString(searchStr))),
          )(coach),
        displayFavorites: either(
          complement(Boolean),
          always(favoritesMaybe?.includes?.(coach.username)),
        ),
      }),
    )(coachesFilter);
